import { makeAutoObservable } from 'mobx';

class SnackStore {
  snackTemplate = {
    message: 'Teste',
    severity: 'success',
    open: false
  };

  snack = { ...this.snackTemplate };

  constructor() {
    makeAutoObservable(this);
  }

  handleSnackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    this.snack = {...this.snackTemplate};
  };

  showSuccessSnack = (message) => {
    this.snack = {
      message: message,
      severity: 'success',
      open: true
    };
  }

  showErrorSnack = (message) => {
    this.snack = {
      message: message,
      severity: 'error',
      open: true
    };
  }
}

export default SnackStore;
